import Campaign from "./campaign";

import sync from "shared/invoca_sync";

import LocalDataTable from "backdraft-app/src/data_table/local_data_table";
import Row from "backdraft-app/src/data_table/row";

import Collection from "backdraft-app/src/collection";

import _ from "underscore";

export class TableRow extends Row {
  get renderers() {
    return {};
  }

  columns() {
    return [
      { bulk: true },
      { attr: "name", title: "Name" },
      { attr: "status", title: "Campaign Status" }
    ];
  }
}

const CampaignsCollection = Collection.extend({
  model: Campaign,
  sync
});

export default class CampaignSelectorTable extends LocalDataTable {
  constructor(options) {
    const collection = new CampaignsCollection();
    collection.url = options.listUrl;

    const defaults = {
      rowClass: TableRow,
      collection
    };

    super(_.extend(defaults, options));

    this._discoverColumnIndecies();
    this.on("reorder", this._onColReorder, this);
  }

  campaignFilter(status, nameFilter) {
    let isRegexp = false;
    let statusFilter;

    if (status === "all") {
      statusFilter = "";
    } else if (status === "active") {
      statusFilter = "Live|Pending";
      isRegexp = true;
    } else if (status === "paused") {
      statusFilter = "Paused";
    }

    this.filter(nameFilter, this._columnIndexName);
    this.filter(statusFilter, this._columnIndexStatus, isRegexp);
  }

  _discoverColumnIndecies() {
    _.each(this.columnsConfig(), function(c, index) {
      if (c.title === "Name") {
        this._columnIndexName = index;
      } else if (c.title === "Campaign Status") {
        this._columnIndexStatus = index;
      }
    }, this);
  }

  _onColReorder() {
    this._discoverColumnIndecies();
  }
}

_.extend(CampaignSelectorTable.prototype, {
  layout: "<'table-wrapper-with-footer't><'row table-footer-controls'<'col-4'lr><'col-8'pi>>",
  sorting: [[0, "desc"], [1, "asc"]],
  paginateLengthMenu: [10, 20, 50, 100],
  paginateLength: 20
});
